import { UtilityService } from './index'

class CustomerServices {
    async listCustomer(page) {
        let result = await fetch(UtilityService.baseUrl() +'api/customer/customers', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body : JSON.stringify({
                page : page
            })
        });
        return {
            text : await result.json(),
            status : result.status,
        };
    }

    async customerInfo() {
        let result = await fetch(UtilityService.baseUrl() + 'api/meetingnotes/customerDetails', {
            method: "GET",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
        });
        return {
            status : result.status,
            text : await result.json()
        };
    }

    async customerWithDepartmentInfo() {
        let result = await fetch(UtilityService.baseUrl() + 'api/report/listCustomersDeparts', {
            method: "GET",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
        });
        return {
            status : result.status,
            text : await result.json()
        };
    }


    
    
    async getCustomer(id) {
        let result = await fetch(UtilityService.baseUrl() + 'api/customer/getCustomer', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                _id:id
            })
        });
        return {
            text : await result.json(),
            status : result.status
        };
    }
    async removeCustomer(id) {
        let result = await fetch(UtilityService.baseUrl() + 'api/customer/customer', {
            method: "DELETE",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                _id: id
            })
        });
        return {
            text : await result.json(),
            status : result.status
        };
    }

    
    async getSystemValuesForCustomer() {
        let result = await fetch(UtilityService.baseUrl() + 'api/system/Customers', {
            method: "GET",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
        });
        return result.json();
    }

    async createCustomer(customer){

        let result = await fetch(UtilityService.baseUrl() + 'api/customer/AddNewCustomer', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify(customer)
        })
        return  {
            status : result.status,
            text :  await result.json()
        };
    }


    async addDepartment(value,id){
        let result = await fetch(UtilityService.baseUrl() + 'api/customer/addCustomerDepartment',{
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body:JSON.stringify({
                departments : value,
                _id:id
            })

        });
        return result.json();
    }

    
    async editCustomer(customerId,customerName, customerCode, customerCRRAccountDetails, auditType, customerDiscount, fabricBasicRequirements, sites) {
        let result = await fetch(UtilityService.baseUrl() + 'api/customer/AddNewCustomer', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                _id: customerId,
                customerName: customerName,
                customerCode: customerCode,
                customerCRRAccountDetails: customerCRRAccountDetails,
                auditType: auditType,
                customerDiscount: customerDiscount,
                sites: sites,
                fabricBasicRequirements: fabricBasicRequirements
            })
        });
        return result.json();
    }

    async searchCustomersBy(customerType,value ,page){
        let result = await fetch(UtilityService.baseUrl() + 'api/customer/searchCustomer', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                for: value,
                by: customerType,
                page : page 
            })
        });
        return { 
            text : await result.json(),
            status : result.status
        };
    }

    
    async getShippingMethod(value) {
        let result = await fetch(UtilityService.baseUrl() + 'api/customer/getShippingMethod', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                text: value
            })
        });
        return result.json();
    }
    async getShippingMode(value) {
        let result = await fetch(UtilityService.baseUrl() + 'api/customer/getShippingMode', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                text: value
            })
        });
        return result.json();
    }
    async getShippingTerm(value) {
        let result = await fetch(UtilityService.baseUrl() + 'api/customer/getShippingTerm', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                text: value
            })
        });
        return result.json();
    }

    
    async getSampleType(value) {
        let result = await fetch(UtilityService.baseUrl() + 'api/customer/getSampleType', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                text: value
            })
        });
        return result.json();
    }

    async systemTrim(value) {
        console.log(value, "value");
        let result = await fetch(UtilityService.baseUrl() + 'api/system/SystemTrims', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify(value)
        });
        return result.json();
    }

    async createpomMaster(value){
        let result = await fetch(UtilityService.baseUrl() + 'api/Pom/createpomMaster',{
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken") 
            },
            body: JSON.stringify(value)
        });
        // return result.json();
        return  {
            status : result.status,
            text :  await result.json()
        };
    }
    async getPomMaster(id){
        let result = await fetch(UtilityService.baseUrl() + `api/Pom/getpomMaster/${id}`,{
            method: "GET",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken") 
            },
        });
        return {
            status: result.status,
            text: await result.json()
        }
    }
    async garmentPomSave(payload,id){
        let result = await fetch(UtilityService.baseUrl() + `api/customer/${id}/garmentdetails`,{
            method: "PUT",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken") 
            },
            body:JSON.stringify(payload)
        });
        return  {
            status : result.status,
            text :  await result.json()
        };
    }

    async garmentPomDelete(customerId,garmId){
        let result = await fetch(UtilityService.baseUrl() + `api/customer/${customerId}/pom/${garmId}`,{
            method: "DELETE",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken") 
            },
        });
        return  {
            status : result.status,
            text :  await result.json()
        };
    }
}
export default new CustomerServices();


// WEBPACK FOOTER //
// ./src/services/customer.service.js